var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"missions__header"},[_c('h4',{staticClass:"missions__label"},[_vm._v(_vm._s(_vm.$t("missions.list.header")))]),_vm._v(" "),_c('MissionsTimer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }